import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      margin: "auto",
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    list: {
      display: "grid",
      marginBlock: theme.spacing(2),
      gap: theme.spacing(1),
    },
    cardTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: theme.spacing(2),
    },
    cardList: {
      marginBlock: theme.spacing(1),
    },
    cardListItem: {
      marginBottom: theme.spacing(0.5),
    },
    property: {
      marginBottom: theme.spacing(2),
    },
  })
);
